<template>
<div class="chapter">
<div class="inner_page">
<h3 class="t3b">PREFACE
</h3>
<p class="calibre7">
In two previous volumes of this work a narrative has
been given of those events which occurred upon the
British Western Front during 1914, the year of recoil,
and 1915, the year of equilibrium.  In this volume
will be found the detailed story of 1916, the first of
the years of attack and advance.
</p>
<p class="calibre7">
Time is a great toner down of superlatives, and
the episodes which seem world-shaking in our day
may, when looked upon by the placid eyes of historical
philosophers in days to come, fit more easily into the
general scheme of human experience.  None the less
it can be said without fear of ultimate contradiction
that nothing approaching to the Battle of the Somme,
with which this volume is mainly concerned, has ever
been known in military history, and that it is
exceedingly improbable that it will ever be equalled in its
length and in its severity.  It may be said to have
raged with short intermissions, caused by the breaking
of the weather, from July 1 to November 14, and
during this prolonged period the picked forces of
three great nations were locked in close battle.  The
number of combatants from first to last was between
<a id="Pvi" title="{vi}"></a>
two and three millions, and their united casualties
came to the appalling total of at least three-quarters
of a million.  These are minimum figures, but they
will give some idea of the unparalleled scale of the
operations.
</p>
<p class="calibre7">
With the increasing number and size of the units
employed the scale of the narrative becomes larger.
It is more difficult to focus the battalion, while the
individual has almost dropped out of sight.  Sins
of omission are many, and the chronicler can but
plead the great difficulty of his task and regret that
his limited knowledge may occasionally cause
disappointment.
</p>
<p class="calibre7">
The author should explain that this volume has
had to pass through three lines of censors, suffering
heavily in the process.  It has come out with the
loss of all personal names save those of casualties
or of high Generals.  Some passages also have been
excised.  On the other hand it is the first which has
been permitted to reveal the exact identity of the
units engaged.  The missing passages and names will
be restored when the days of peace return.
</p>
<p class="noindent">
ARTHUR CONAN DOYLE.
</p>
<p class="noindent">
<i class="calibre9">February</i> 3, 1918.
</p>
<p class="calibre7">
<a id="Pvii" title="{vii}"></a>
</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?69ebd7ca